import { ModelBase } from 'store/model-base';

export class NowPauseCancelPort extends ModelBase {
    public static storeName: string = 'nowPauseCancelPort';

    public pauseIntent: string;
    public cancelIntent: string;
    public transferXALink: string;
    public portOutXALink: string;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowPauseCancelPort = super.create<NowPauseCancelPort>(initData);

        return super.create<T>(toReturn);
    }
}
